import React, {FC} from 'react'

import cn from 'classnames/bind'

import s from './Price.module.scss'
const cx = cn.bind(s)

interface IPriceProps {
	currency: string
	price: number
	priceTitle: string
	className?: string
}

const Price: FC<IPriceProps> = ({currency, price, priceTitle, className}) => {
	return (
		<div className={cx('price-box', className)}>
			<div className={cx('regular')}>
				<div className={cx('regular__price')}>
					{currency}
					{price}
				</div>
				<div className={cx('regular__title')}>{priceTitle}</div>
			</div>
		</div>
	)
}

Price.displayName = 'Price'

export default Price
